/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserAuthInfoResponse} from '../models/UserAuthInfoResponse';

export interface AssignGuidToUser$Request {
    userId: number;
}

export interface AssignGuidToUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const assignGuidToUserRequest = createAction<PayloadData<void, AssignGuidToUser$Request>>('USER_AUTHENTICATION_INFO__ASSIGN_GUID_TO_USER__REQUEST');
export const assignGuidToUserSuccess = createAction<PayloadData<UserAuthInfoResponse, AssignGuidToUser$Request>>('USER_AUTHENTICATION_INFO__ASSIGN_GUID_TO_USER__SUCCESS');
export const assignGuidToUserFailure = createAction<PayloadData<Error, AssignGuidToUser$Request, true>>('USER_AUTHENTICATION_INFO__ASSIGN_GUID_TO_USER__FAILURE');

export const assignGuidToUserActions = [
    assignGuidToUserRequest,
    assignGuidToUserSuccess,
    assignGuidToUserFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const assignGuidToUser = (meta: AssignGuidToUser$Request, config?: AssignGuidToUser$Config) => {
    return {
        CALL_API: {
            types: assignGuidToUserActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/authentication-info`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface EnforceUserMfa$Request {
    userId: number;
    enforceStatus: boolean;
    primaryEmailMfa: boolean;
    reason?: string;
}

export interface EnforceUserMfa$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const enforceUserMfaRequest = createAction<PayloadData<void, EnforceUserMfa$Request>>('USER_AUTHENTICATION_INFO__ENFORCE_USER_MFA__REQUEST');
export const enforceUserMfaSuccess = createAction<PayloadData<void, EnforceUserMfa$Request>>('USER_AUTHENTICATION_INFO__ENFORCE_USER_MFA__SUCCESS');
export const enforceUserMfaFailure = createAction<PayloadData<Error, EnforceUserMfa$Request, true>>('USER_AUTHENTICATION_INFO__ENFORCE_USER_MFA__FAILURE');

export const enforceUserMfaActions = [
    enforceUserMfaRequest,
    enforceUserMfaSuccess,
    enforceUserMfaFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} meta.enforceStatus
 * @param {boolean} meta.primaryEmailMfa
 * @param {string} [meta.reason] Optional audit reason for this update. Blank values use the existing operation-specific reason.
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const enforceUserMfa = (meta: EnforceUserMfa$Request, config?: EnforceUserMfa$Config) => {
    const TRANSPORT_GET_PARAMS = {
        reason: meta.reason,
        enforceStatus: meta.enforceStatus,
        primaryEmailMfa: meta.primaryEmailMfa,
    };
    return {
        CALL_API: {
            types: enforceUserMfaActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/${meta.userId}/authentication-info/enforce`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUserAuthenticationInfo$Request {
    userId: number;
}

export interface GetUserAuthenticationInfo$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUserAuthenticationInfoRequest = createAction<PayloadData<void, GetUserAuthenticationInfo$Request>>('USER_AUTHENTICATION_INFO__GET_USER_AUTHENTICATION_INFO__REQUEST');
export const getUserAuthenticationInfoSuccess = createAction<PayloadData<UserAuthInfoResponse, GetUserAuthenticationInfo$Request>>('USER_AUTHENTICATION_INFO__GET_USER_AUTHENTICATION_INFO__SUCCESS');
export const getUserAuthenticationInfoFailure = createAction<PayloadData<Error, GetUserAuthenticationInfo$Request, true>>('USER_AUTHENTICATION_INFO__GET_USER_AUTHENTICATION_INFO__FAILURE');

export const getUserAuthenticationInfoActions = [
    getUserAuthenticationInfoRequest,
    getUserAuthenticationInfoSuccess,
    getUserAuthenticationInfoFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUserAuthenticationInfo = (meta: GetUserAuthenticationInfo$Request, config?: GetUserAuthenticationInfo$Config) => {
    return {
        CALL_API: {
            types: getUserAuthenticationInfoActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/authentication-info`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface ResetUserMfa$Request {
    userId: number;
}

export interface ResetUserMfa$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const resetUserMfaRequest = createAction<PayloadData<void, ResetUserMfa$Request>>('USER_AUTHENTICATION_INFO__RESET_USER_MFA__REQUEST');
export const resetUserMfaSuccess = createAction<PayloadData<void, ResetUserMfa$Request>>('USER_AUTHENTICATION_INFO__RESET_USER_MFA__SUCCESS');
export const resetUserMfaFailure = createAction<PayloadData<Error, ResetUserMfa$Request, true>>('USER_AUTHENTICATION_INFO__RESET_USER_MFA__FAILURE');

export const resetUserMfaActions = [
    resetUserMfaRequest,
    resetUserMfaSuccess,
    resetUserMfaFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const resetUserMfa = (meta: ResetUserMfa$Request, config?: ResetUserMfa$Config) => {
    return {
        CALL_API: {
            types: resetUserMfaActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/authentication-info/reset`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface UnlockUser$Request {
    userId: number;
}

export interface UnlockUser$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const unlockUserRequest = createAction<PayloadData<void, UnlockUser$Request>>('USER_AUTHENTICATION_INFO__UNLOCK_USER__REQUEST');
export const unlockUserSuccess = createAction<PayloadData<void, UnlockUser$Request>>('USER_AUTHENTICATION_INFO__UNLOCK_USER__SUCCESS');
export const unlockUserFailure = createAction<PayloadData<Error, UnlockUser$Request, true>>('USER_AUTHENTICATION_INFO__UNLOCK_USER__FAILURE');

export const unlockUserActions = [
    unlockUserRequest,
    unlockUserSuccess,
    unlockUserFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const unlockUser = (meta: UnlockUser$Request, config?: UnlockUser$Config) => {
    return {
        CALL_API: {
            types: unlockUserActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/${meta.userId}/authentication-info/unlock`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

